<template>
  <div class="container-receipt h-full bg-grey-receipt p-2">
    <slot class="overflow-x-hidden" />
  </div>
</template>
